/**
 * Workspace wordmark. Inter Tight 700 followed by a 6px orange square.
 * Rendered in CSS rather than as an asset per the MAXART convention.
 *
 * Reference: Claude Design Files README section 10.
 */

import { cn } from '@/lib/utils';

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-[6px] font-display text-[18px] font-bold leading-none text-mx-white',
        className,
      )}
      aria-label="Workspace"
    >
      <span>Workspace</span>
      <span aria-hidden className="inline-block h-[6px] w-[6px] bg-mx-orange" />
    </span>
  );
}
